import { useEffect, useState } from 'react';
import { v } from '@/theme/tokens';

/** Read-only offline mode: cached data stays visible, mutations need a network. */
export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (!offline) return null;
  return (
    <div
      role="status"
      style={{
        background: v('warning-soft'), color: v('warning'),
        padding: '8px 16px', fontSize: 13, fontWeight: 600, textAlign: 'center',
      }}
    >
      Офлайн — доступны последние сохранённые данные. Импорт, корректировки и комментарии требуют подключения.
    </div>
  );
}
